module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldPreload && _vm.zoomImage && _vm.zoomImage.src) ? _c('span', [_c('link', {
    attrs: {
      "rel": "preload",
      "href": _vm.zoomImage.src,
      "as": "image"
    }
  }), _vm._v(" "), _c('img', {
    ref: "image",
    class: _vm.image.className,
    style: (_vm.getImageStyle()),
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    },
    on: {
      "click": _vm.handleZoom
    }
  })]) : _c('img', {
    ref: "image",
    class: _vm.image.className,
    style: (_vm.getImageStyle()),
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    },
    on: {
      "click": _vm.handleZoom
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/12.2.2/vue-loader/lib/template-compiler?{"id":"data-v-512589e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.npminstall/vue-loader/12.2.2/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageZoom.vue
// module id = 56
// module chunks = 1